import { CountryId } from "./config/countryId";
import { Country } from "./types/Country";
import { ref } from 'vue';

export function useCountriesRepository() {
    return {
        countries: ref<Country[]>([]),
    };
}

export {
    CountryId,
    Country,
}